import { NAME } from './constants';
import { router } from './router';
import { apiProvider } from './api';
import Select from './components/Select.vue';

export const NdCenik = {
	name: NAME,
	components: { Select },
	router,
	apiProvider,
};
